import { RootScopeEvents } from 'common/services/root-scope-types';
import growthbook, { getGrowthbookFeatures } from './global.experiments.ts';

export default angular
  .module('doxy.global.growthbook', [])
  .factory('growthbookFactory', function ($rootScope) {
    this.growthbook = growthbook;

    const update = (newGrowthbook) => {
      this.growthbook = newGrowthbook;
      $rootScope.$emit(RootScopeEvents.GROWTHBOOK_UPDATE);
    };

    const getFeature = (name) => {
      return this.growthbook.feature(name);
    };

    const getFeatureAsync = async (name) => {
      if (this.growthbook.feature(name).source === 'unknownFeature') {
        await getGrowthbookFeatures();
      }
      return this.growthbook.feature(name);
    };

    return {
      getFeature,
      update,
      getFeatureAsync,
    };
  }).name;
